import React from 'react';
import { useSource } from '../../contexts/SourceContext';

import { Bot } from 'lucide-react';

const SourceMarker = ({ sourceNumber, onClick, isOpen, isNotInContext, messageId }) => {
  const { hoveredSource, setHoveredSource } = useSource();

  const handleClick = () => {
    if (onClick) {
      onClick(sourceNumber);
    }
  };

  const handleMouseEnter = () => {
    setHoveredSource({ messageId: messageId, number: sourceNumber });
  };

  const handleMouseLeave = () => {
    setHoveredSource(null);
  };

  const isHovered = hoveredSource && hoveredSource.messageId === messageId && hoveredSource.number === sourceNumber;

  return (
    <span
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`relative inline-flex items-center justify-center w-6 h-6 text-sm font-bold align-middle transition-all duration-200 ease-in-out rounded-full cursor-pointer ${isHovered || isOpen ? 'scale-110 bg-primary text-primary-foreground' : 'bg-border text-muted-foreground'}`}
    >
      {isNotInContext ? <Bot className="w-4 h-4" /> : sourceNumber}
    </span>
  );
};

export { SourceMarker };
